export const mockConferences = [
  {
    slug: 'react-summit-2026',
    title: 'React Summit 2026',
    description: 'The biggest React conference worldwide. Deep dives into full-stack development, architecture, AI-assisted coding, and growing to senior & tech lead roles.',
    event_type: 'HYBRID',
    start_date: '2026-06-12',
    end_date: '2026-06-16',
    website: 'https://reactsummit.com',
    is_favorite: true,
    cover: {
      url: 'https://reactsummit.com/img/ogimage.png'
    },
    logo: {
      url: 'https://reactsummit.com/img/logo.svg'
    },
    address: {
      unit: null,
      street: 'Kromhouthallen',
      city: 'Amsterdam',
      state: null,
      country: 'Netherlands',
      lat: 52.3676,
      lng: 4.9041
    },
    speakers: [
      {
        id: 1,
        first_name: 'Scott',
        last_name: 'Tolinski',
        position: 'Creator',
        company: 'Level Up Tutorials',
        linkedin_url: 'https://linkedin.com/in/stolinski',
        image: {
          url: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=250'
        }
      },
      {
        id: 2,
        first_name: 'Kadi',
        last_name: 'Kraman',
        position: 'Software Developer',
        company: 'Expo',
        linkedin_url: 'https://linkedin.com/in/kadikraman',
        image: {
          url: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=250'
        }
      },
      {
        id: 3,
        first_name: 'Dominik',
        last_name: 'Dorfmeister',
        position: 'Frontend Engineer',
        company: 'Sentry',
        linkedin_url: 'https://linkedin.com/in/dominikdorfmeister',
        image: {
          url: 'https://images.unsplash.com/photo-1566492031773-4f4e44671857?w=250'
        }
      },
      {
        id: 4,
        first_name: 'Aurora',
        last_name: 'Scharff',
        position: 'Software Developer & Microsoft MVP',
        company: 'Crayon Consulting',
        linkedin_url: 'https://linkedin.com/in/aurorascharff',
        image: {
          url: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=250'
        }
      },
      {
        id: 5,
        first_name: 'Jemima',
        last_name: 'Abu',
        position: 'Frontend Developer & GDE',
        company: 'Google Developer Expert',
        linkedin_url: 'https://linkedin.com/in/jemimaabu',
        image: {
          url: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=250'
        }
      }
    ],
    organization: {
      name: 'GitNation',
      description: 'GitNation is a foundation contributing to the development of the technological landscape by organizing events which focus on the open source software.',
      website: 'https://gitnation.com',
      image: {
        url: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=175'
      }
    }
  },
  {
    slug: 'jsnation-2026',
    title: 'JSNation 2026',
    description: 'The main JavaScript conference of 2026. Discover the future of web development ecosystem with full-stack engineering, AI-assisted coding, and AI engineering.',
    event_type: 'HYBRID',
    start_date: '2026-06-11',
    end_date: '2026-06-15',
    website: 'https://jsnation.com',
    is_favorite: false,
    cover: {
      url: 'https://jsnation.com/img/ogimage.png'
    },
    logo: {
      url: 'https://jsnation.com/img/logo.svg'
    },
    address: {
      unit: null,
      street: 'Kromhouthallen',
      city: 'Amsterdam',
      state: null,
      country: 'Netherlands',
      lat: 52.3676,
      lng: 4.9041
    },
    speakers: [
      {
        id: 6,
        first_name: 'Matt',
        last_name: 'Pocock',
        position: 'TypeScript Educator',
        company: 'Total TypeScript',
        linkedin_url: 'https://linkedin.com/in/mattpocock',
        image: {
          url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=250'
        }
      },
      {
        id: 7,
        first_name: 'Jason',
        last_name: 'Williams',
        position: 'Senior Software Engineer',
        company: 'Bloomberg',
        linkedin_url: 'https://linkedin.com/in/jasonwilliams',
        image: {
          url: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=250'
        }
      },
      {
        id: 8,
        first_name: 'Liang',
        last_name: 'Gong',
        position: 'Software Engineer & MemLab Creator',
        company: 'Meta',
        linkedin_url: 'https://linkedin.com/in/lianggong',
        image: {
          url: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=250'
        }
      },
      {
        id: 9,
        first_name: 'Anna',
        last_name: 'Henningsen',
        position: 'Database Experience Team',
        company: 'MongoDB',
        linkedin_url: 'https://linkedin.com/in/annahenningsen',
        image: {
          url: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=250'
        }
      }
    ],
    organization: {
      name: 'GitNation',
      description: 'GitNation is a foundation contributing to the development of the technological landscape by organizing events which focus on the open source software.',
      website: 'https://gitnation.com',
      image: {
        url: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=175'
      }
    }
  },
  {
    slug: 'aws-reinvent-2026',
    title: 'AWS re:Invent 2026',
    description: 'Amazon Web Services\' annual cloud computing conference featuring keynotes, training sessions, and networking with cloud experts.',
    event_type: 'IN_PERSON',
    start_date: '2026-11-30',
    end_date: '2026-12-04',
    website: 'https://reinvent.awsevents.com',
    is_favorite: false,
    cover: {
      url: 'https://www.cxtoday.com/wp-content/uploads/2026/01/Amazon-AWS-reInvent-2026-CX-AI.jpg'
    },
    logo: {
      url: 'https://www.cxtoday.com/wp-content/uploads/2026/01/Amazon-AWS-reInvent-2026-CX-AI.jpg'
    },
    address: {
      unit: null,
      street: 'The Venetian',
      city: 'Las Vegas',
      state: 'Nevada',
      country: 'United States',
      lat: 36.1215,
      lng: -115.1693
    },
    speakers: [
      {
        id: 27,
        first_name: 'Adam',
        last_name: 'Selipsky',
        position: 'CEO',
        company: 'AWS',
        linkedin_url: 'https://linkedin.com/in/adamselipsky',
        image: {
          url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=250'
        }
      },
      {
        id: 28,
        first_name: 'Swami',
        last_name: 'Sivasubramanian',
        position: 'VP of AI & Data',
        company: 'AWS',
        linkedin_url: 'https://linkedin.com/in/swaminathansivasubramanian',
        image: {
          url: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=250'
        }
      },
      {
        id: 29,
        first_name: 'Werner',
        last_name: 'Vogels',
        position: 'CTO',
        company: 'Amazon',
        linkedin_url: 'https://linkedin.com/in/wernervogels',
        image: {
          url: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=250'
        }
      }
    ],
    organization: {
      name: 'Amazon Web Services',
      description: 'The world\'s most comprehensive and broadly adopted cloud platform, offering over 200 fully featured services.',
      website: 'https://aws.amazon.com',
      image: {
        url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Amazon_Web_Services_Logo.svg/960px-Amazon_Web_Services_Logo.svg.png'
      }
    }
  },
  {
    slug: 'adobe-summit-vqfy32fq',
    title: 'Adobe Summit',
    description: 'The premier digital experience conference bringing together marketers, creatives, and developers to explore the future of customer experiences.',
    event_type: 'HYBRID',
    start_date: '2026-08-25',
    end_date: '2026-08-27',
    website: 'https://summit.adobe.com',
    is_favorite: false,
    cover: {
      url: 'https://summit.adobe.com/_assets/images/global/summit-open-social.jpg?v=26.1.0'
    },
    logo: {
      url: 'https://summit.adobe.com/_assets/images/global/summit-open-social.jpg?v=26.1.0'
    },
    address: {
      unit: null,
      street: '3799 S Las Vegas Blvd',
      city: 'Las Vegas',
      state: 'Nevada',
      country: 'United States',
      lat: 36.1699,
      lng: -115.1398
    },
    speakers: [
      {
        id: 21,
        first_name: 'Shantanu',
        last_name: 'Narayen',
        position: 'CEO',
        company: 'Adobe',
        linkedin_url: 'https://linkedin.com/in/shantanunarayen',
        image: {
          url: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=250'
        }
      },
      {
        id: 22,
        first_name: 'Ashley',
        last_name: 'Still',
        position: 'SVP Digital Media',
        company: 'Adobe',
        linkedin_url: 'https://linkedin.com/in/ashleystill',
        image: {
          url: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=250'
        }
      },
      {
        id: 23,
        first_name: 'Scott',
        last_name: 'Belsky',
        position: 'Chief Strategy Officer',
        company: 'Adobe',
        linkedin_url: 'https://linkedin.com/in/scottbelsky',
        image: {
          url: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=250'
        }
      }
    ],
    organization: {
      name: 'Adobe',
      description: 'Leading software company for creative, marketing and document management solutions.',
      website: 'https://summit.adobe.com',
      image: {
        url: 'https://raw.githubusercontent.com/lobehub/lobe-icons/refs/heads/master/packages/static-png/dark/adobe-color.png'
      }
    }
  },
  {
    slug: 'elixir-conf-eu-2026-4cfercfw',
    title: 'ElixirConf EU 2026',
    description: 'The premier European conference for the Elixir programming language. Learn from core team members and community experts about functional programming and the BEAM ecosystem.',
    event_type: 'HYBRID',
    start_date: '2026-07-15',
    end_date: '2026-07-17',
    website: 'https://www.elixirconf.eu',
    is_favorite: true,
    cover: {
      url: 'https://2022.elixirconf.com/images/resources/JoseKeynote.jpg'
    },
    logo: {
      url: 'https://2022.elixirconf.com/images/resources/JoseKeynote.jpg'
    },
    address: {
      unit: null,
      street: 'Calle Alcazabilla',
      city: 'Malaga',
      state: null,
      country: 'Spain',
      lat: 36.7213,
      lng: -4.4214
    },
    speakers: [
      {
        id: 18,
        first_name: 'José',
        last_name: 'Valim',
        position: 'Creator of Elixir',
        company: 'Dashbit',
        linkedin_url: 'https://linkedin.com/in/josevalim',
        image: {
          url: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=250'
        }
      },
      {
        id: 19,
        first_name: 'Andrea',
        last_name: 'Leopardi',
        position: 'Elixir Core Team',
        company: 'Community',
        linkedin_url: 'https://linkedin.com/in/andrealeopardi',
        image: {
          url: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=250'
        }
      },
      {
        id: 20,
        first_name: 'Chris',
        last_name: 'McCord',
        position: 'Creator of Phoenix Framework',
        company: 'Fly.io',
        linkedin_url: 'https://linkedin.com/in/chrismccord',
        image: {
          url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=250'
        }
      }
    ],
    organization: {
      name: 'Elixir Foundation',
      description: 'Supporting the Elixir programming language and its ecosystem.',
      website: 'https://elixirconf.eu',
      image: {
        url: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=175'
      }
    }
  },
  {
    slug: 'kubecon-cloudnativecon-eu-2026',
    title: 'KubeCon + CloudNativeCon Europe 2026',
    description: 'The flagship conference for cloud native computing, bringing together adopters and technologists from leading open source and cloud native communities.',
    event_type: 'IN_PERSON',
    start_date: '2026-03-24',
    end_date: '2026-03-26',
    website: 'https://events.linuxfoundation.org/kubecon-cloudnativecon-europe/',
    is_favorite: true,
    cover: {
      url: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800'
    },
    logo: {
      url: 'https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9?w=200'
    },
    address: {
      unit: null,
      street: 'RAI Amsterdam',
      city: 'Amsterdam',
      state: null,
      country: 'Netherlands',
      lat: 52.3376,
      lng: 4.8897
    },
    speakers: [
      {
        id: 12,
        first_name: 'Kelsey',
        last_name: 'Hightower',
        position: 'Principal Engineer',
        company: 'Google Cloud',
        linkedin_url: 'https://linkedin.com/in/kelseyhightower',
        image: {
          url: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=250'
        }
      },
      {
        id: 13,
        first_name: 'Priyanka',
        last_name: 'Sharma',
        position: 'Executive Director',
        company: 'CNCF',
        linkedin_url: 'https://linkedin.com/in/pritianka',
        image: {
          url: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=250'
        }
      },
      {
        id: 14,
        first_name: 'Brendan',
        last_name: 'Burns',
        position: 'Corporate VP',
        company: 'Microsoft',
        linkedin_url: 'https://linkedin.com/in/brendan-burns',
        image: {
          url: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=250'
        }
      }
    ],
    organization: {
      name: 'Cloud Native Computing Foundation',
      description: 'The Cloud Native Computing Foundation builds sustainable ecosystems and fosters communities to support the growth of cloud native open source software.',
      website: 'https://www.cncf.io',
      image: {
        url: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=175'
      }
    }
  },
  {
    slug: 'appjs-conf-2026',
    title: 'App.js Conf 2026',
    description: 'The biggest React Native & Expo conference in Europe. Meet creators and contributors to React Native and Expo, share ideas, and shape the future of app development.',
    event_type: 'IN_PERSON',
    start_date: '2026-05-27',
    end_date: '2026-05-29',
    website: 'https://appjs.co',
    is_favorite: false,
    cover: {
      url: 'https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800'
    },
    logo: {
      url: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=200'
    },
    address: {
      unit: null,
      street: 'ICE Kraków Congress Centre',
      city: 'Kraków',
      state: null,
      country: 'Poland',
      lat: 50.0647,
      lng: 19.9450
    },
    speakers: [
      {
        id: 15,
        first_name: 'Evan',
        last_name: 'Bacon',
        position: 'Engineering Manager',
        company: 'Expo',
        linkedin_url: 'https://linkedin.com/in/evanbacon',
        image: {
          url: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=250'
        }
      },
      {
        id: 16,
        first_name: 'Satyajit',
        last_name: 'Sahoo',
        position: 'Software Engineer',
        company: 'Expo',
        linkedin_url: 'https://linkedin.com/in/satya164',
        image: {
          url: 'https://images.unsplash.com/photo-1566492031773-4f4e44671857?w=250'
        }
      },
      {
        id: 17,
        first_name: 'Nicola',
        last_name: 'Corti',
        position: 'Developer Advocate',
        company: 'Meta',
        linkedin_url: 'https://linkedin.com/in/nicolacorti',
        image: {
          url: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=250'
        }
      }
    ],
    organization: {
      name: 'Software Mansion',
      description: 'Software Mansion is a software development company specializing in building mobile and web applications.',
      website: 'https://swmansion.com',
      image: {
        url: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=175'
      }
    }
  },
  {
    slug: 'github-universe-2026',
    title: 'GitHub Universe 2026',
    description: 'The flagship event for developers building the future with AI-powered development tools, open source, and collaborative coding.',
    event_type: 'HYBRID',
    start_date: '2026-10-29',
    end_date: '2026-10-30',
    website: 'https://githubuniverse.com',
    is_favorite: true,
    cover: {
      url: 'https://images.unsplash.com/photo-1618044733300-9472054094ee?w=800'
    },
    logo: {
      url: 'https://images.unsplash.com/photo-1618401471353-b98afee0b2eb?w=200'
    },
    address: {
      unit: null,
      street: 'Fort Mason Center',
      city: 'San Francisco',
      state: 'California',
      country: 'United States',
      lat: 37.8057,
      lng: -122.4312
    },
    speakers: [
      {
        id: 24,
        first_name: 'Thomas',
        last_name: 'Dohmke',
        position: 'CEO',
        company: 'GitHub',
        linkedin_url: 'https://linkedin.com/in/ashtom',
        image: {
          url: 'https://images.unsplash.com/photo-1566492031773-4f4e44671857?w=250'
        }
      },
      {
        id: 25,
        first_name: 'Inbal',
        last_name: 'Shani',
        position: 'Chief Product Officer',
        company: 'GitHub',
        linkedin_url: 'https://linkedin.com/in/inbalshani',
        image: {
          url: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=250'
      }
      },
      {
        id: 26,
        first_name: 'Kyle',
        last_name: 'Daigle',
        position: 'COO',
        company: 'GitHub',
        linkedin_url: 'https://linkedin.com/in/kdaigle',
        image: {
          url: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=250'
        }
      }
    ],
    organization: {
      name: 'GitHub',
      description: 'The world\'s leading platform for software development and collaboration, now part of Microsoft.',
      website: 'https://github.com',
      image: {
        url: 'https://upload.wikimedia.org/wikipedia/commons/9/91/Octicons-mark-github.svg'
      }
    }
  },
  {
    slug: 'vue-conf-us-2026',
    title: 'VueConf US 2026',
    description: 'The official Vue.js conference in the United States, featuring talks from core team members and community leaders.',
    event_type: 'IN_PERSON',
    start_date: '2026-05-13',
    end_date: '2026-05-14',
    website: 'https://vueconf.us',
    is_favorite: true,
    cover: {
      url: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=800'
    },
    logo: {
      url: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=200'
    },
    address: {
      unit: null,
      street: 'New Orleans Ernest N. Morial Convention Center',
      city: 'New Orleans',
      state: 'Louisiana',
      country: 'United States',
      lat: 29.9511,
      lng: -90.0715
    },
    speakers: [
      {
        id: 30,
        first_name: 'Evan',
        last_name: 'You',
        position: 'Creator of Vue.js',
        company: 'Independent',
        linkedin_url: 'https://linkedin.com/in/evanyou',
        image: {
          url: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=250'
        }
      },
      {
        id: 31,
        first_name: 'Sarah',
        last_name: 'Drasner',
        position: 'VP of Developer Experience',
        company: 'Google',
        linkedin_url: 'https://linkedin.com/in/sarahdrasner',
        image: {
          url: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=250'
        }
      },
      {
        id: 32,
        first_name: 'Anthony',
        last_name: 'Fu',
        position: 'Core Team Member',
        company: 'NuxtLabs',
        linkedin_url: 'https://linkedin.com/in/antfu',
        image: {
          url: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=250'
        }
      }
    ],
    organization: {
      name: 'Vue.js Community',
      description: 'The progressive JavaScript framework community, making web development approachable and performant.',
      website: 'https://vuejs.org',
      image: {
        url: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=175'
      }
    }
  }
]
